import React, { useEffect } from "react";
import "./Header.css";
import { AiOutlineShopping } from "react-icons/ai";
import { FaLocationArrow } from "react-icons/fa";
import { TbTruckDelivery } from "react-icons/tb";
import { Link, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import {
  getCart,
  cartData,
  showHalfCart
} from "../../features/products/productSlice";
import {
  initialLocation,
  allLocations,
  getLocations
} from "../../features/locations/locationSlice";

import UserDropdown from "../DropdownMenu/DropDownMenu";
import SearchBar from "../SearchBar/SearchBar";
import CartDrawer from "../Basket/CartDrawer/CartDrawer";
import { getDeliverySlot } from "../../util/delivery";

/**
 * Component that displays the Header Page page
 *
 * @return {JSX.Element} Header Page component JSX
 */
function Header() {
  const dispatch = useDispatch();
  const basket = useSelector(cartData);
  const selectedLocation = useSelector(initialLocation);
  const locationsList = useSelector(allLocations);
  const { pathname } = useLocation();

  useEffect(() => {
    dispatch(getLocations());
    dispatch(getCart());
  }, [dispatch]);

  const handleCartClick = () => {
    dispatch(showHalfCart(true));
  };

  // Get display name for customer location safely
  const customerLocation = selectedLocation
    ? selectedLocation.apartmentName ||
      selectedLocation.addressLine1 ||
      selectedLocation.addressLine2 ||
      ""
    : "";

  // Helper: Format a time string like "10:30"
  const formatTime = (time) => {
    if (!time || typeof time !== "string" || !time.includes(":")) return "";
    const [h, m] = time.split(":");
    const date = new Date();
    date.setHours(parseInt(h, 10), parseInt(m, 10));
    return date.toLocaleTimeString("en-IN", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true
    });
  };

  // Safe computation of deliverySlotTimes
  const deliverySlotTimes =
    selectedLocation && selectedLocation.id
      ? getDeliverySlot(
          [{ ...selectedLocation, locationId: selectedLocation.id }],
          locationsList
        )
      : null;

  // Safely format delivery date
  const deliveryDate = deliverySlotTimes?.deliveryDateTime
    ? deliverySlotTimes.deliveryDateTime.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit"
      })
    : "";

  // Safely format cutoff time
  const cutOffTime = deliverySlotTimes?.targetTime
    ? deliverySlotTimes.targetTime.toLocaleTimeString("en-IN", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true
      })
    : "";

  // Safely compute next delivery slot range
  const nextDeliverySlot =
    deliverySlotTimes?.from && deliverySlotTimes?.to
      ? `${deliveryDate} ${formatTime(deliverySlotTimes.from)} – ${formatTime(
          deliverySlotTimes.to
        )}`
      : "";

  return (
    <>
      <header className="header">
        <nav className="nav">
          <Link to="/" className="logo">
            <img src="/images/green_yogi_logo_80.png" alt="Green Yogi Logo" />
          </Link>

          <div className="search_header">
            {pathname === "/" && <SearchBar />}
          </div>

          <div className="icon_Sopping_box">
            <div className="shoppe_icon_box" onClick={handleCartClick}>
              <AiOutlineShopping className="shop_icon" />
              <span className="nav_text">Cart</span>
              {basket.items?.length > 0 && (
                <span className="badge_shope">{basket.items.length}</span>
              )}
            </div>
            <UserDropdown className="mark_icon" />
          </div>
        </nav>
      </header>

      <CartDrawer />

      <div className="selected_location">
        <div>
          <FaLocationArrow />
          <span>{customerLocation}</span>
        </div>
      </div>

      <div className="deliveryTime">
        <div>
          <TbTruckDelivery />
          <span>
            Order by {cutOffTime}, get it {nextDeliverySlot}
          </span>
        </div>
      </div>
    </>
  );
}

export default Header;
